import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';

enum TagType {
  NEW = 'NEW',
  ACTION = 'ACTION',
  SALEOUT = 'SALEOUT',
}

interface Props {
  text: string;
  type: string;
  theme?: any;
}

function Tag({ text, type, theme }: Props) {
  const loadColorBasedOnItemType = () => {
    switch (type) {
      case TagType.NEW: {
        return theme.colors.white;
      }
      case TagType.ACTION: {
        return theme.colors.white;
      }
      case TagType.SALEOUT: {
        return theme.colors.black;
      }
      default: {
        return theme.colors.black;
      }
    }
  };

  const loadBgColorBasedOnItemType = () => {
    switch (type) {
      case TagType.NEW: {
        return theme.tagColors.new;
      }
      case TagType.ACTION: {
        return theme.tagColors.action;
      }
      case TagType.SALEOUT: {
        return theme.tagColors.saleout;
      }
      default: {
        return 'transparent';
      }
    }
  };
  const color = loadColorBasedOnItemType();
  const bgColor = loadBgColorBasedOnItemType();

  return (
    <Wrapper color={color} bgColor={bgColor}>
      {text}
    </Wrapper>
  );
}

const Wrapper = styled.div<{ color: string; bgColor: string }>`
  padding: ${rem(3)} ${rem(12)};
  text-align: center;
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${rem(2)};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  text-transform: uppercase;
`;

const withThemeTag: any = withTheme(Tag);
export { withThemeTag as Tag, TagType };
